<template>
  <el-card class="page-container">
    <h1 class="title-biaoti">主播流量总览数据</h1>
    <el-row :gutter="20" class="user-options">
      <el-col :span="6">
        <el-date-picker
          v-model="platformData"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="retainedOptions"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="3">
        <el-select
          filterable
          style="width: 160px"
          v-model="country"
          placeholder=""
        >
          <el-option
            v-for="(item, itemIndex) in countryList"
            v-bind:key="itemIndex + 99"
            :label="item.country"
            :value="item.countryCode"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-input v-model="hostRid" placeholder="主播id 选填"></el-input>
      </el-col>
      <el-col :span="3">
        <el-select
          filterable
          style="width: 160px"
          v-model="language"
          placeholder=""
        >
          <el-option
            v-for="(item, itemIndex) in languageList"
            v-bind:key="itemIndex + 99"
            :label="item.language"
            :value="item.langCode"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
        <el-button type="warning" @click="getDayChatDetai" :loading="login1">
          查询
        </el-button>
        <el-button type="success" @click="dwnDayChatDetai" :loading="login2">
          下载
        </el-button>
      </el-col>
    </el-row>
    <el-row class="user-options">
      <el-table
        :data="dayChatDetailData"
        style="width: 100%"
        v-loading="login1"
        stripe
        border
      >
        <el-table-column prop="date" fixed label="日期" width="200">
        </el-table-column>

        <el-table-column prop="hostRid" fixed label="主播ID" width="180">
        </el-table-column>
        <el-table-column prop="hostLevel" label="主播等级" width="180">
        </el-table-column>

        <el-table-column prop="language" label="语言设置" width="180">
        </el-table-column
        ><el-table-column prop="area" label="区域" width="180">
        </el-table-column
        ><el-table-column prop="status" label="新老主播" width="180">
          <template slot-scope="scope">
            <div>
              {{ scope.row.status ? "新" : "老" }}
            </div>
          </template> </el-table-column
        ><el-table-column
          prop="onlineTime"
          label="在线时长-h"
          width="180"
          sortable
        >
        </el-table-column
        >
        <el-table-column
          prop="liveTime"
          label="live 时长"
          width="180"
          sortable
        >
        </el-table-column
        >
        <el-table-column
          prop="exposeCount"
          label="曝光总次数"
          width="180"
          sortable
        >
        </el-table-column
        ><el-table-column
          prop="exposeUserCount"
          label="曝光总人数"
          width="180"
          sortable
        >
        </el-table-column
        ><el-table-column
          prop="avgExposeCount"
          label="人均浏览次数"
          width="180"
          sortable
        >
        </el-table-column
        ><el-table-column
          prop="totalCallCount"
          label="总拨打次数"
          width="180"
          sortable
        >
        </el-table-column
        ><el-table-column prop="callRate" label="拨打率" width="180">
        </el-table-column
        ><el-table-column
          prop="activeExposeCount"
          label="有效曝光次数"
          width="180"
          sortable
        >
        </el-table-column
        ><el-table-column
          prop="activeCallCount"
          label="总有效拨打次数"
          width="180"
          sortable
        >
        </el-table-column
        ><el-table-column
          prop="callSuccessCount"
          label="接通次数"
          width="180"
          sortable
        >
        </el-table-column>

        <el-table-column
          prop="callSuccessRate"
          label="接通率"
          width="180"
          sortable
        >
        </el-table-column
        ><el-table-column
          prop="chatTime"
          label="总通话时长-s"
          width="180"
          sortable
        >
        </el-table-column
        ><el-table-column
          prop="avgChatTime"
          label="平均通话时长-s"
          width="180"
          sortable
        >
        </el-table-column
        ><el-table-column
          prop="chatGolds"
          label="通话金币收入"
          width="180"
          sortable
        >
        </el-table-column
        ><el-table-column
          prop="giftGolds"
          label="礼物金币收入"
          width="180"
          sortable
        >
        </el-table-column
        ><el-table-column prop="totalGolds" label="总收入" width="180" sortable>
        </el-table-column
        ><el-table-column
          prop="hundredAvgGolds"
          label="每百次曝光收入"
          width="180"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="hundredAvgActiveGolds"
          label="每百次有效曝光收入"
          width="180"
          sortable
        >
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="user-options">
      <el-pagination
        :current-page.sync="page"
        layout="total, prev, pager, next"
        background
        @current-change="handleCurrentChange"
        :total="total"
        class="pagination"
        :page-size="30"
      ></el-pagination>
    </el-row>
  </el-card>
</template>

<script>
import download from '@/utils/download.js'
import { datainfor } from '@/utils/formdata.js'
import { getCountry, getLanguage } from '@/utils/normalApi.js'

export default {
  data() {
    return {
      // 加载
      login1: false,
      login2: false,
      // 用户id白名单 MultipartFile文件
      ridFile: '',
      // 代理名或者代理id
      agentName: '',
      // 通话日期
      platformData: [datainfor(1), datainfor(1)],
      retainedOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      // 分引
      page: 1,
      total: 0,
      // 表格数据
      dayChatDetailData: [],

      country: 'total',
      countryList: [],
      hostRid: '',
      language: 'all',
      languageList: []
    }
  },
  async created() {
    await this._getLanguage()
    this.getDayChatDetai()
    this._getCountry()
  },
  methods: {
    async _getCountry() {
      const res = await getCountry()
      if (res !== null) {
        this.countryList = res.countryList
      }
    },
    async _getLanguage() {
      const res = await getLanguage()
      if (res !== null) {
        this.languageList = res
        this.language = res[0].langCode
      }
    },
    // 查询列表
    async getDayChatDetai() {
      this.login1 = true

      const { data: res } = await this.$axios({
        type: 'GET',
        url: this.$store.getters.path.host_flow_stat,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          page: this.page,
          country: this.country,
          hostRid: this.hostRid,
          language: this.language
        }
      })
      this.login1 = false
      if (res.code != 0) return this.$message(res.msg)
      this.dayChatDetailData = res.data.data
      this.total = res.data.total
    },
    // 下载
    async dwnDayChatDetai() {
      this.login2 = true
      const res = await this.$axios({
        method: 'GET',
        url: this.$store.getters.path.pay_goods_download,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'blob',
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          country: this.country,
          hostRid: this.hostRid,
          language: this.language
        }
      })

      this.$message.success('开始下载')
      this.login2 = false
      console.log(res.data)
      download(res.data, '主播流量总览数据' + this.platformData[1])
    },
    // 分页
    handleCurrentChange() {
      this.getDayChatDetai()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.page-container {
  margin-left: 20px;
  margin-top: 20px;

  .el-col {
    display: flex;
    align-items: center;

    >div {
      margin-right: 5px;
    }
  }

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;

    .line {
      width: 1440px;
      height: 700px;
    }
  }
}
</style>
